// extracted by mini-css-extract-plugin
export default {"actionButtons":"RulePanel_actionButtons__yiXIK"};